export const getFlights = state => state.toJS();

export const getMeals = (flights, routeId) => {
  let currentFlight = flights.find(flight => flight.routeId === routeId);
  if (currentFlight) {
    return currentFlight.meals;
  }
  return [];
};

export const getMealsForFlight = flight => flight.seats;

export const getSelectedMeals = (flights, routeId) => {
  let currentFlight = flights.find(flight => flight.routeId === routeId);
  if (currentFlight) {
    return getSelectedMealsForFlight(currentFlight);
  }
  return [];
};

export const getSelectedMealsForFlight = flight => {
  const { meals, selectedMeals } = flight;
  if (meals && meals.category) {
    selectedMeals.filter(passenger => {
      if (passenger && passenger.meals) {
        passenger.meals.filter(selectedMeal => {
          meals.category.filter(meal => {
            if (meal && meal.items) {
              let selected = meal.items.find(item => item.id === selectedMeal.id);
              if (selected) {
                if (meal.label && meal.label.toLowerCase()) {
                  selectedMeal.type = meal.label.toLowerCase();
                }
              }
            }
          });
        });
      }
    });
  }
  return selectedMeals;
};



// WEBPACK FOOTER //
// ./src/redux/selectors/MealsSelectors.js